import { useEffect, useState } from 'react';
import { secondsLeft } from '../api/use-cart.js';

/**
 * Ticks once a second, and only while there is something to count.
 *
 * A stale cart should be discovered as it lapses rather than at checkout, so
 * reaching zero tells the screen rather than just showing 0:00.
 */
export function useCountdown(expiresAt: string | null, onExpired?: () => void): number | null {
  const [left, setLeft] = useState(() => (expiresAt ? secondsLeft(expiresAt) : null));

  useEffect(() => {
    if (!expiresAt) {
      setLeft(null);
      return;
    }

    setLeft(secondsLeft(expiresAt));

    const tick = setInterval(() => {
      const remaining = secondsLeft(expiresAt);
      setLeft(remaining);
      if (remaining === 0) {
        clearInterval(tick);
        onExpired?.();
      }
    }, 1000);

    return () => clearInterval(tick);
    // onExpired is written inline by callers and would restart the interval
    // every render; the expiry is what the countdown is about.
  }, [expiresAt]);

  return left;
}
